import { useState } from "react";
import SiteNav from "@/components/feature/SiteNav";
import SiteFooter from "@/components/feature/SiteFooter";
import Hero from "@/pages/home/components/Hero";
import Directions from "@/pages/home/components/Directions";
import PlayModes from "@/pages/home/components/PlayModes";
import MovieLibrary from "@/pages/home/components/MovieLibrary";
import Genres from "@/pages/home/components/Genres";
import Preview from "@/pages/home/components/Preview";
import Series from "@/pages/home/components/Series";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Updates from "@/pages/home/components/Updates";
import Closing from "@/pages/home/components/Closing";

export default function Home() {
  const [genreFilter, setGenreFilter] = useState("全部");

  const pickGenre = (genre: string) => {
    setGenreFilter(genre);
    const el = document.getElementById("library");
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SiteNav />
      <main>
        <Hero />
        <Directions />
        <PlayModes />
        <MovieLibrary genreFilter={genreFilter} onGenreFilterChange={setGenreFilter} />
        <Genres onPick={pickGenre} />
        <Preview />
        <Series />
        <Guide />
        <Faq />
        <Updates />
        <Closing />
      </main>
      <SiteFooter />
    </div>
  );
}